import {
    IBannerVariables, VariablesType,
} from "./types";
import {AtLeastOne, IdObjectsWithId} from "../../../utils";
import {createAction, createAsyncAction} from "typesafe-actions";


export const fetchBannerVariablesByIdAsyncActions = createAsyncAction(
    'FETCH_BANNER_VARIABLES_BY_ID_REQUEST',
    'FETCH_BANNER_VARIABLES_BY_ID_SUCCESS',
    'FETCH_BANNER_VARIABLES_BY_ID_FAILURE'
)<{ id: string }, { bannerVariables: IBannerVariables }, { error: Error }>();


export const fetchBannerVariablesAsyncActions = createAsyncAction(
    'FETCH_BANNER_VARIABLES_REQUEST',
    'FETCH_BANNER_VARIABLES_SUCCESS',
    'FETCH_BANNER_VARIABLES_FAILURE'
)<{}, { bannerVariablesList: IdObjectsWithId<IBannerVariables> }, { error: Error }>();

export const saveBannerVariablesAsyncActions = createAsyncAction(
    'SAVE_BANNER_VARIABLES_REQUEST',
    'SAVE_BANNER_VARIABLES_SUCCESS',
    'SAVE_BANNER_VARIABLES_FAILURE'
)<{ bannerVariables: AtLeastOne<IBannerVariables, { id: { id: string } }> }, { bannerVariables: IBannerVariables }, { error: Error }>();

export const deleteBannerVariablesAsyncActions = createAsyncAction(
    'DELETE_BANNER_VARIABLES_REQUEST',
    'DELETE_BANNER_VARIABLES_SUCCESS',
    'DELETE_BANNER_VARIABLES_FAILURE'
)<{id: string}, {id: string}, { error: Error }>();

export interface IModifyingActiveBannerVariablesActionPayload {
    bannerVariables: Partial<IBannerVariables>;
    variablesType: VariablesType;
    replace: boolean
}
export const modifyingActiveBannerVariablesAction = createAction('MODIFYING_ACTIVE_BANNER_VARIABLES', action => {
    return (params: IModifyingActiveBannerVariablesActionPayload) => action(params);
});

export const modifiedActiveBannerVariablesAction = createAction('MODIFIED_ACTIVE_BANNER_VARIABLES', action => {
    return (bannerVariables: IBannerVariables) => action({bannerVariables: bannerVariables});
});

export interface ISetMasterActiveBannerVariablesActionPayload {
    bannerVariables: IBannerVariables;
    variablesType: VariablesType;
}
export const setMasterActiveBannerVariablesAction = createAction('SET_MASTER_ACTIVE_BANNER_VARIABLES', action => {
    return (params: ISetMasterActiveBannerVariablesActionPayload) => action(params);
});

export interface ISetActiveBannerVariablesByIdActionPayload {
    id: string;
    variablesType: VariablesType;
}
export const setActiveBannerVariablesByIdAction = createAction('SET_ACTIVE_BANNER_VARIABLES_BY_ID', action => {
    return (params: ISetActiveBannerVariablesByIdActionPayload) => action(params);
});

